import { useState, useEffect } from 'react';
import { useUser, useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import {
  buildGetAccountUserOfferingsRequest,
  getUserSubscriptionsProducts,
} from './utils';

const useUserProducts = (accountProducts, fetchUserOfferings) => {
  const [userProducts, setUserProducts] = useState([]);
  const userData = useUser();
  const currentAccountId = useCurrentAccountId();
  const currentUser = userData?.user;

  const {
    data: userOfferingsData,
    doFetch: doGetUserOfferings,
    loading: isFetchingUserOfferings,
  } = useDataApi();

  useEffect(() => {
    if (!currentUser?.id || !currentAccountId || !fetchUserOfferings) return;

    doGetUserOfferings(
      buildGetAccountUserOfferingsRequest(currentAccountId, currentUser.id)
    );
  }, [
    currentAccountId,
    currentUser?.id,
    doGetUserOfferings,
    fetchUserOfferings,
  ]);

  useEffect(() => {
    if (!userOfferingsData) {
      setUserProducts(accountProducts);
    } else {
      const userSubscriptionsProducts = getUserSubscriptionsProducts(
        userOfferingsData.results
      );
      const products = JSON.parse(JSON.stringify(accountProducts));
      userSubscriptionsProducts.forEach((subscriptionProduct) => {
        const accountProduct = products.find(
          (p) => p.type === subscriptionProduct.type
        );
        if (!accountProduct) {
          products.push(subscriptionProduct);
        } else if (!accountProduct.included) {
          accountProduct.included = true;
        }
      });
      setUserProducts(products);
    }
  }, [accountProducts, userOfferingsData]);

  return { userProducts, isFetchingUserOfferings };
};

export default useUserProducts;
